const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const CreateReportMachine = createMachine(
  {
    /** @xstate-layout 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 */
    predictableActionArguments: true,

    id: "create-report",

    context: {
      consequenceTypes: null,
      correctiveActionSources: null,
      severityTypes: null,
      probabilityTypes: null,
      locations: null,
      targetTypes: null,
      categories: null,
      report: {
        event: null,
      },
      error: null,
      authentication: {
        token: null,
      },
      qmsToolApiUrl: null,
    },

    states: {
      processing: {
        initial: "initialization",

        states: {
          initialization: {
            states: {
              "fetch consequence types": {
                invoke: {
                  src: "fetchConsequenceTypes",
                  id: "fetch-consequence-types",

                  onDone: {
                    target:
                      "#create-report.processing.fetch corrective action sources",
                    actions: "saveConsequenceTypes",
                  },

                  onError: "error",
                },
              },

              "fetch severity types": {
                invoke: {
                  src: "fetchSeverityTypes",
                  id: "fetch-severity-types",

                  onDone: {
                    target: "fetch probability types",
                    actions: "saveSeverityTypes",
                  },

                  onError: "error",
                },
              },

              "fetch probability types": {
                invoke: {
                  src: "fetchProbabilityTypes",
                  id: "fetch-probability-types",

                  onDone: {
                    target: "fetch locations",
                    actions: "saveProbabilityTypes",
                  },

                  onError: "error",
                },
              },

              "fetch locations": {
                invoke: {
                  src: "fetchLocations",
                  id: "fetch-locations",

                  onDone: {
                    target: "fetch target types",
                    actions: "saveLocations",
                  },

                  onError: "error",
                },
              },

              "fetch target types": {
                invoke: {
                  src: "fetchTargetTypes",
                  id: "fetch-target-types",

                  onDone: {
                    target: "fetch categories",
                    actions: "saveTargetTypes",
                  },

                  onError: "error",
                },
              },

              "fetch categories": {
                invoke: {
                  src: "fetchCategories",
                  id: "fetch-categories",

                  onDone: {
                    target: "fetch domains",
                    actions: "saveCategories",
                  },

                  onError: "error",
                },
              },

              error: {
                entry: "raiseInitializationError",

                on: {
                  INITIALIZATION_ERROR: {
                    target: "#create-report.processing.error",
                    internal: true,
                  },
                },
              },

              "waiting token": {
                always: {
                  target: "waiting edit report machine ref",
                  cond: "tokenReady",
                },
              },

              "fetch domains": {
                invoke: {
                  src: "fetchDomains",
                  id: "fetch-domains",
                  onError: "error",

                  onDone: {
                    target: "fetch user's restricted domains",
                    actions: "saveDomains",
                  },
                },
              },

              "fetch user's affiliated residences": {
                invoke: {
                  src: "fetchResidences",
                  id: "fetch-residences",
                  onDone: {
                    target: "fetch consequence types",
                    actions: "saveResidences",
                  },
                  onError: "error",
                },
              },

              "waiting edit report machine ref": {
                always: {
                  target: "fetch user's affiliated residences",
                  cond: "editReportMachineRef",
                },
              },

              "fetch user's restricted domains": {
                invoke: {
                  src: "fetchUserRestrictedDomains",

                  onDone: {
                    target: "#create-report.processing.initialized",
                    actions: "saveUserRestrictedDomains",
                  },

                  onError: "error",
                },
              },
            },

            initial: "waiting token",
          },

          error: {
            entry: ["saveError", "notifyError"],

            on: {
              RETRY: {
                target: "initialization",
                internal: true,
              },
            },
          },

          initialized: {
            initial: "idle",

            states: {
              idle: {
                on: {
                  START: {
                    target: "active",
                    cond: "userHasAffiliatedResidences",
                  },
                },
              },

              active: {
                initial: "selection of the consequence",

                states: {
                  "selection of the consequence": {
                    on: {
                      NEXT: {
                        target: "identification of the criticity",
                        cond: "validSelectedResidenceAndConsequence",
                      },

                      ABANDON_REQUESTED: "confirm abandon",
                    },

                    states: {
                      idle: {
                        on: {
                          CONSEQUENCE_SELECTED: {
                            target: "compute criticity",
                            cond: "validSelectedConsequenceTypeObject",
                            actions: [
                              "saveSelectedConsequenceTypeEventKey",
                              "saveSelectedConsequenceTypeFormObject",
                              "resetComputedCriticityType",
                              "resetReportEventCriticity",
                              "resetSeverityType",
                              "resetProbabilityType",
                            ],
                          },

                          RESIDENCE_SELECTED: {
                            target: "idle",
                            internal: true,
                            cond: "validResidence",
                            actions: "saveSelectedResidenceEventKey",
                          },
                        },
                      },

                      "compute criticity": {
                        invoke: {
                          src: "computeCriticityFromConsequence",
                          id: "compute-criticity-from-consequence",

                          onDone: {
                            target: "idle",
                            actions: [
                              "saveComputedCriticityType",
                              "saveForcedValues",
                            ],
                          },

                          onError: "error",
                        },
                      },

                      error: {
                        always: "idle",
                        entry: ["saveError", "notifyError"],
                      },
                    },

                    initial: "idle",
                  },

                  "identification of the criticity": {
                    on: {
                      PREVIOUS: "selection of the consequence",

                      NEXT: {
                        target: "event description",
                        cond: "validCriticityType",
                      },
                    },

                    states: {
                      "check selected consequence": {
                        always: [
                          {
                            target: "forced criticity event",
                            cond: "forcedCriticity",
                          },
                          {
                            target: "computable criticity",
                            cond: "computableCrititicy",
                          },
                        ],
                      },

                      "forced criticity event": {
                        entry: [
                          "saveForcedValues",
                          "saveForcedSeverityType",
                          "saveForcedProbabilityType",
                        ],
                      },

                      "computable criticity": {
                        states: {
                          idle: {
                            on: {
                              SEVERITY_SELECTED: {
                                target: "compute criticity",
                                cond: "validSelectedSeverity",
                                actions: ["saveSelectedSeverity"],
                              },

                              PROBABILITY_SELECTED: {
                                target: "compute criticity",
                                cond: "validSelectedProbability",
                                actions: "saveSelectedProbability",
                              },
                            },
                          },

                          "compute criticity": {
                            invoke: {
                              src: "computeCriticity",
                              id: "compute-criticity",

                              onDone: {
                                target: "idle",
                                actions: "saveComputedCriticityType",
                              },

                              onError: "error",
                            },
                          },

                          error: {
                            always: "idle",
                            entry: "saveError",
                          },
                        },

                        initial: "idle",
                      },
                    },

                    initial: "check selected consequence",
                  },

                  "event description": {
                    on: {
                      PREVIOUS: "identification of the criticity",

                      DESCRIPTION_CHANGED: {
                        target: "event description",
                        internal: true,
                        cond: "validReceivedEventDescription",
                        actions: "saveEventDescription",
                      },

                      NEXT: {
                        target: "event context",
                        cond: "validEventDateAndDescription",
                      },

                      PERIOD_OF_THE_DAY_SELECTED: {
                        target: "event description",
                        cond: "validEventPeriodOfTheDay",
                        actions: "saveEventPeriodOfTheDay",
                        internal: true,
                      },

                      OCCURENCE_DATE_SELECTED: {
                        target: "event description",
                        cond: "validEventOccurenceDate",
                        actions: [
                          "saveEventOccurenceDate",
                          "computeEventPeriodOfTheDay",
                        ],
                        internal: true,
                      },
                    },
                  },

                  "report actions summary": {
                    on: {
                      CLOSE: "#create-report.processing.initialized.idle",
                      VIEW_REPORT: {
                        target: "#create-report.processing.initialized.idle",
                        actions: "sendLoadReportEvent",
                      },
                    },

                    exit: [
                      "resetComputedCriticityType",
                      "resetSeverityType",
                      "resetProbabilityType",
                      "resetReportEventCriticity",
                      "resetConsequenceType",
                      "resetReportEvent",
                      "resetLocation",
                      "resetTarget",
                      "resetCategory",
                      "resetDomain",
                    ],
                  },

                  "create report": {
                    initial: "creating report",

                    states: {
                      "creating report": {
                        invoke: {
                          src: "createReport",
                          id: "create-report",
                          onDone: {
                            target:
                              "#create-report.processing.initialized.active.report actions summary",
                            actions: "saveResult",
                          },
                          onError: "error",
                        },
                      },

                      error: {
                        entry: "saveError",

                        states: {
                          "check error type": {
                            always: [
                              {
                                target: "access denied",
                                cond: "accessDeniedError",
                              },
                              "server error",
                            ],
                          },

                          "access denied": {
                            on: {
                              ABANDON_REQUESTED:
                                "#create-report.processing.initialized.active.confirm abandon",
                            },
                          },
                          "server error": {
                            on: {
                              RETRY:
                                "#create-report.processing.initialized.active.create report.creating report",
                            },
                          },
                        },

                        initial: "check error type",
                      },
                    },
                  },

                  "confirm creation": {
                    on: {
                      CREATE: {
                        target: "create report",
                        cond: "allRequiredFieldsAreValid",
                      },

                      PREVIOUS: "external communication",
                    },
                  },

                  "external communication": {
                    on: {
                      PREVIOUS: "event context",
                      NEXT: "confirm creation",

                      AUTHORITY_INFORMED_DATE_SELECTED: {
                        target: "external communication",
                        cond: "validDate",
                        actions: "saveAuthorityInfoDate",
                        internal: true,
                      },

                      FAMILY_INFORMED_DATE_SELECTED: {
                        target: "external communication",
                        cond: "validDate",
                        actions: "saveFamilyInfoDate",
                        internal: true,
                      },

                      REGIONAL_DIRECTION_INFORMED_DATE_SELECTED: {
                        target: "external communication",
                        internal: true,
                        cond: "validDate",
                        actions: "saveRegionalDirectionInfoDate",
                      },

                      GENERAL_PRACTITIONER_INFORMED_DATE_SELECTED: {
                        target: "external communication",
                        internal: true,
                        actions: "saveGeneralPractionerInfoDate",
                      },
                    },
                  },

                  "confirm abandon": {
                    on: {
                      ABANDON: {
                        target: "#create-report.processing.initialized.aborted",
                        actions: [
                          "resetComputedCriticityType",
                          "resetProbabilityType",
                          "resetSeverityType",
                          "resetReportEventCriticity",
                          "resetConsequenceType",
                          "resetReportEvent",
                          "resetLocation",
                          "resetTarget",
                          "resetCategory",
                          "resetDomain",
                        ],
                      },

                      CANCEL_ABANDON: "selection of the consequence",
                    },
                  },

                  "event context": {
                    on: {
                      NEXT: {
                        target: "external communication",
                        cond: "validEventContextFormData",
                      },

                      PREVIOUS: "event description",

                      LOCATION_SELECTED: {
                        target: "event context",
                        cond: "validEventLocation",
                        actions: "saveEventLocation",
                        internal: true,
                      },

                      TARGET_SELECTED: {
                        target: "event context",
                        cond: "validEventTarget",
                        actions: "saveEventTarget",
                        internal: true,
                      },

                      CATEGORY_SELECTED: {
                        target: "event context",
                        cond: "validEventCategory",
                        actions: "saveEventCategory",
                        internal: true,
                      },

                      DOMAIN_SELECTED: {
                        target: "event context",
                        cond: "validEventDomain",
                        actions: "saveEventDomain",
                        internal: true,
                      },
                    },
                  },
                },
              },

              aborted: {
                always: "idle",
              },
            },
          },

          "fetch corrective action sources": {
            invoke: {
              src: "fetchCorrectiveActionSources",

              onDone: {
                target: "fetch corrective action priorities",
                actions: "saveCorrectiveActionSources",
              },

              onError: "initialization.error",
            },
          },

          "fetch corrective action priorities": {
            invoke: {
              src: "fetchCorrectiveActionPriorities",
              onDone: {
                target: "fetch corrective action manager types",
                actions: "saveCorrectiveActionPriorities",
              },
              onError: "initialization.error",
            },
          },

          "fetch corrective action manager types": {
            invoke: {
              src: "fetchCorrectiveActionManagerTypes",

              onDone: {
                target: "initialization.fetch severity types",
                actions: "saveCorrectiveActionManagerTypes",
              },

              onError: "initialization.error",
            },
          },
        },
      },

      "updating token": {
        on: {
          UPDATE_BEARER_TOKEN: {
            target: "updating token",
            cond: "validToken",
            actions: ["saveToken"],
            internal: true,
          },
        },
      },

      "updating edit report machine ref": {
        on: {
          SET_EDIT_REPORT_MACHINE_REF: {
            target: "updating edit report machine ref",
            internal: true,
            actions: "saveEditReportMachineRef",
          },
        },
      },
    },

    type: "parallel",
  },
  {
    actions: actions,
    guards: guards,
    services: services,
  },
);

export { CreateReportMachine };
